import { useState } from "react";
import type { Place, PlaceGroup } from "../types";
import { matchesQuery, SearchField } from "./fields";

type Props = {
  groups: PlaceGroup[];
  places: Place[];
  selectedGroup: string;
  busy: boolean;
  onSelect: (id: string) => void;
  onCreate: (name: string) => Promise<void>;
};

export default function GroupsSidebar({ groups, places, selectedGroup, busy, onSelect, onCreate }: Props) {
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  function count(id: string): number {
    if (id === "all") return places.length;
    if (id === "none") return places.filter((p) => !p.group_id).length;
    return places.filter((p) => p.group_id === id).length;
  }

  const items: { id: string; label: string }[] = [
    { id: "all", label: "Tous" },
    { id: "none", label: "Sans groupe" },
    ...groups
      .filter((g) => matchesQuery(g.name, query))
      .map((g) => ({ id: g.id, label: g.name })),
  ];

  return (
    <div className="pr-card flex flex-wrap items-center gap-2 px-4 py-3">
      <div className="w-full min-w-[180px] sm:w-56">
        <SearchField value={query} onChange={setQuery} placeholder="Filtrer les groupes" />
      </div>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          className={`pr-chip ${selectedGroup === item.id ? "is-on" : "is-off"}`}
        >
          {item.label}
          <span className="ml-1 opacity-60">{count(item.id)}</span>
        </button>
      ))}
      {open ? (
        <form
          className="flex items-center gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            const next = name.trim();
            if (!next) return;
            void onCreate(next).then(() => {
              setName("");
              setOpen(false);
            });
          }}
        >
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom du groupe" className="pr-input w-44" />
          <button type="submit" disabled={busy} className="pr-btn">
            Créer
          </button>
          <button type="button" className="pr-btn-ghost" onClick={() => setOpen(false)}>
            Annuler
          </button>
        </form>
      ) : (
        <button type="button" className="pr-chip is-off" onClick={() => setOpen(true)}>
          Nouveau groupe
        </button>
      )}
    </div>
  );
}
